import { Component, Input } from '@angular/core';
import { ProvidersService } from 'fccore2';
import { FcinputComponent } from '../fcinput';
/**
 * fc-rateè¯å
 * 
 * è¯åç»ä»¶ã
 * 
 * å¯¹è¯ä»·è¿è¡å±ç¤ºãå¯¹äºç©è¿è¡å¿«éçè¯çº§æä½ã
 * 
 */
@Component({
    selector: 'fc-rate',
    template: `
    <nz-rate *ngIf="fcShowLabel==='N'"[ngClass]="{'fc-rate-small':fcSize === 'small','fc-rate-default':fcSize === 'default','fc-rate-large':fcSize === 'large'}" 
    [(ngModel)]="innerValue" (ngModelChange)="checkValidator($event)" [nzAllowHalf]="allowHalf" [nzAllowClear]="allowClear"
    [nzDisabled]="_disabled" [nzCount]="fcCount"></nz-rate>
    <span *ngIf="fcText!==undefined" class="ant-rate-text">{{fcCount}} æ</span>
    <div nz-row  nzType="flex" class="rowspans"  *ngIf="fcShowLabel===undefined||fcShowLabel==='Y'">
        <div nz-col [nzSpan]="labelSpan" class="labelspans"><span *ngIf="fcRequired==='Y'" style="color:red">*</span>{{fcLabel}}</div>
        <div nz-col [nzSpan]="valueSpan">
            <nz-rate [ngClass]="{'fc-rate-small':fcSize === 'small','fc-rate-default':fcSize === 'default','fc-rate-large':fcSize === 'large'}" 
                    [(ngModel)]="innerValue" (ngModelChange)="checkValidator($event)" [nzAllowHalf]="allowHalf" [nzAllowClear]="allowClear"
                    [nzDisabled]="_disabled" [nzCount]="fcCount"></nz-rate>
            <span *ngIf="fcText!==undefined" class="ant-rate-text">{{fcCount}} æ</span>
            <div class="explain" *ngIf="_validator!==undefined&&_validator.show==='Y'">
                <div [hidden]="_validator.showValidator!=='required'" class="explain-inner">
                    <div class="explain-tips">{{_validator.errorMessages.required}}</div>
                </div>
                <div [hidden]="_validator.showValidator!=='maxLength'" class="explain-inner">
                    <div class="explain-tips">{{_validator.errorMessages.maxLength}}</div>
                </div>
                <div [hidden]="_validator.showValidator!=='customVal'" class="explain-inner">
                    <div class="explain-tips">{{_validator.errorMessages.customVal}}</div>
                </div>
            </div>
        </div>
    </div>
    `,
    styles: [`
    .form-explain {
        position:relative;
    }
    .explain{
        white-space: nowrap;
        position:absolute;
        right: -1px;
        bottom: 24px;
        z-index:10;
    }
    .explain-inner {
        position:relative;
        color:red;
    }
    .explain-inner:after{
        content: '';
        width: 10px;
        height: 12px;
        display: block;
        background-color: #ffffff;
        border-right: 1px solid #e9e9e9;
        border-bottom: 1px solid #e9e9e9;
        position: absolute;
        bottom: -6px;
        right: 12px;
        transform: rotate(45deg);
        z-index: 0;
    }
    .explain-tips{
        padding: 0px 10px;
        background-color: #ffffff;
        border: 1px solid #e9e9e9;
        border-radius: 4px;
        font-size: 12px;
        height: 30px;
        line-height: 28px;
    }
    `]
})
export class FcrateComponent extends FcinputComponent {
    /** å½åæ°*/
    @Input()
    innerValue;
    /** æææ»æ°*/
    @Input()
    fcCount: number; /**é»è®¤ä¸º5æï¼*/
    /** ä¸»å¯¹è±¡å¼*/
    @Input()
    mainObj: any;
    /** æ¯å¦è¿è¡åæéæ©*/
    @Input()
    fcAllowHalf: string;
    allowHalf: boolean;
    /** æ¯å¦æ¸é¤*/
    @Input()
    fcAllowClear: string;
    allowClear: boolean;
    /** å¤§å°*/
    @Input()
    fcSize: string = 'default';
    /**æ¯å¦æ¾ç¤ºææ¡*/
    @Input()
    fcText: string;
    constructor(public provider: ProvidersService) {
        super(provider, 'fc-rate');

    }
    ngOnChanges(param): void {
        super.ngOnChanges(param);

    }
    _afterParentInit() {
        if (this.innerValue === undefined) {
            this.innerValue = 0;
        }
        if (this.fcCount === undefined) {
            this.fcCount = 5;
        }
        if (this.fcAllowClear === undefined) {
            this.allowClear = false;
        }
        /**æ¯æåæ*/
        if (this.fcAllowHalf === 'Y') {
            this.allowHalf = true;
            this.innerValue = 2.5;
        } else {
            this.allowHalf = false;
        }
        /**æ¯ææ¸é¤*/
        if (this.fcAllowClear === 'Y') {
            this.allowClear = true;
        } else {
            this.allowClear = false;
        }
        /**æ¯å¦ç¦ç¨*/
        if (this.fcDisabled === 'Y') {
            this._disabled = true;
        } else {
            this._disabled = false;
        }
        /**æ¯å¦åªè®*/
        if (this.fcReadonly === 'Y') {
            this._readonly = true;
        } else {
            this._readonly = false;
        }
    }
}
